// Dependencias generales
import React, { useRef } from "react";
import { useEffect } from 'react';
import '../../css/common.css';
import '../../css/initialConfigStyle.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactGA from "react-ga4";

import logoFevergyInforme from '../../img/dark-theme/fevergy-brand-light.svg'

import '../../css/reports.css'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postRetrieveBillingAnalysis = endpointHelias+'/Helias/V0/Advisory/postRetrieveBillingAnalysis'

var advisoryCommonJS = require("../../js/advisoryCommon.js")
var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

// Advisory - Last 12 Bills Analysis
const Last12BillsAnalysis = (params) => {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const analysisId = urlParams.get('analysisId')

  const pdfRef = useRef();
  
  useEffect(() => {   

    if(!window.location.href.includes("InstallerFeesAnalyzer")){

      if(analysisId !== null){
        cargarDatosAnalisis(analysisId)
      }
      else{
        window.location.href="/Asesoramiento"
      }

    }

    console.log("Pantalla de resultados de análisis de tus últimas 12 facturas cargada correctamente.")    

  });

  function copiarEnlace(){
    let texto = ""
    
    if(analysisId !== null){
      texto = window.location.href+"?analysisId="+analysisId
    }
    else{
      texto = window.location.href+"?analysisId="+document.getElementById("CUPSInstalacion").value
    }
    
    try {
      navigator.clipboard.writeText(texto);      
      initialConfigCommonJS.mostrarMensajeInformativo("Enlace del informe copiado al portapapeles.","positive")
    } catch (err) {
      initialConfigCommonJS.mostrarMensajeInformativo("Hubo algún problema al copiar el enlace del informe.","negative")
    } 

  }

  function descargarPDF(){

    document.getElementById("tablaResultadosInforme").style = "width: 680px; "
    document.getElementById("loaderGeneralAplicacion").style = "margin: 0; width: 100vw"

    document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") 

    document.getElementById("divInstruccionesBajadaPotencia").setAttribute("open", "")
    document.getElementById("divBloqueOferta").setAttribute("open", "")
    document.getElementById("acordeonCalculosResultados").setAttribute("open", "")    

    const input = pdfRef.current;

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');

      var imgWidth = 210; 
      var pageHeight = 295;  
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;

      var pdf = new jsPDF('p', 'mm', 'a4', true);
      var position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
      heightLeft -= pageHeight;
      
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
        heightLeft -= pageHeight;
      }      
      
      if(analysisId !== null){
        pdf.save('Análisis_'+analysisId+'.pdf')
      }
      else{
        pdf.save('Análisis_'+document.getElementById("CUPSInstalacion").value+'.pdf')        
      }
      
      document.getElementById("tablaResultadosInforme").style = ""
      document.getElementById("loaderGeneralAplicacion").style = ""

      document.getElementById("divInstruccionesBajadaPotencia").removeAttribute("open")
      document.getElementById("divBloqueOferta").removeAttribute("open")
      document.getElementById("acordeonCalculosResultados").removeAttribute("open")

      document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"

    })

    

  }
  
  function cargarDatosAnalisis(idAnalisis){
    
    document.documentElement.setAttribute('id','informe')

    document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") 
    
    var jsonPeticion = {
      "loadPublicAnalysisResults": idAnalisis
    }
    
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postRetrieveBillingAnalysis, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {

          var jsonRespuesta = JSON.parse(this.responseText)

          if(jsonRespuesta.body.length !== 0){            
            advisoryCommonJS.procesarRespuestaVerificacion(jsonRespuesta)          
                        
            document.title = "HELIAS - Asesoramiento: Análisis 12 facturas"     
            document.querySelector('meta[name="description"]').setAttribute("content", "Análisis de tus últimas 12 facturas");

            window.history.pushState("", "", '/Asesoramiento/Analisis-12-Facturas')              
            generalCommonJS.registrarEventoAnalitica(ReactGA, '12 FACTURAS', "INFORME "+analysisId, "", "")

          }
          else{              
            window.location.href="/Asesoramiento"
          }          

          document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"

        }
      }
      xhttp.send(data);    
    
  }

  return (   

      <div id="global">
        <main id="main"> 
            
          <div id="tablaResultadosInforme" ref={pdfRef}>

            <header>

              <a className="brand" href="https://fevergy.com/" target="_blank" rel="noopener noreferrer">
                <img src={logoFevergyInforme} alt="FEVERGY" height="24"/>
              </a>

              <div className="horizontal gap-04">
                <button className="button secondary rounded size-s" onClick={() => copiarEnlace()}><span className="material-icon">share</span></button>
                <button className="button secondary rounded size-s" onClick={() => descargarPDF()}><span className="material-icon">file_download</span></button>
              </div>

            </header>

            <div className="horizontal">                
              <p id="textoCUPS" className="size-m"></p>                
            </div>           

            <div id="bubbleOfertaEncontrada">

              <span id="textoResumenAhorroTotal" className="size-m"></span>
              
              <div id="divImportesResultados" className="horizontal gap-04">              
                <span id="textoImporteAhorroTotalAño"></span>                
                <span id="textoPorcentajeAhorroTotalAño" className="headline-02"></span>                
              </div>

            </div>       

            <div className="message warning left" >   
              <h1 className="title" style={{color: "black"}}><span className="material-icon">info</span>Sigue las indicaciones cuanto antes...</h1>       
              <p className="size-s" style={{color: "black"}}>Si esperas demasiado podrían cambiar las condiciones y perderías tanto el ahorro como posibles promociones.</p>                              
            </div>
            

            <details id="divInstruccionesBajadaPotencia" className="accordion">

              <summary className="title">
                <figure className="avatar size-l orange"><span className="material-icon">looks_one</span></figure>
                <div className="content vertical">
                  <span id="textoDetailBajadaPotencia" className="size-l">Cambia las condiciones de tu contrato</span>
                </div>
              </summary>

              <div className="accordion-content">
                <span id="textoIntroBajadaPotencia" className="size-m"></span>                
                <ul className="instructions-list">
                  <li id="liTextoBajadaPotenciaP1" className="instructions-step horizontal gap-02">
                    <figure className="size-m"><span className="material-icon">check</span></figure>
                    <span id="textoBajadaPotenciaP1" className="size-m"></span>
                  </li>
                  <li id="liTextoBajadaPotenciaP2" className="instructions-step horizontal gap-02">
                    <figure className="size-m"><span className="material-icon">check</span></figure>
                    <span id="textoBajadaPotenciaP2" className="size-m"></span>
                  </li>
                  <li id="liTextoBajadaPotenciaP3" className="instructions-step horizontal gap-02">
                    <figure className="size-m"><span className="material-icon">check</span></figure>
                    <span id="textoBajadaPotenciaP3" className="size-m"></span>
                  </li>
                  <li id="liTextoBajadaPotenciaP4" className="instructions-step horizontal gap-02">
                    <figure className="size-m"><span className="material-icon">check</span></figure>
                    <span id="textoBajadaPotenciaP4" className="size-m"></span>
                  </li>
                  <li id="liTextoBajadaPotenciaP5" className="instructions-step horizontal gap-02">
                    <figure className="size-m"><span className="material-icon">check</span></figure>
                    <span id="textoBajadaPotenciaP5" className="size-m"></span>
                  </li>
                  <li id="liTextoBajadaPotenciaP6" className="instructions-step horizontal gap-02">
                    <figure className="size-m"><span className="material-icon">check</span></figure>
                    <span id="textoBajadaPotenciaP6" className="size-m"></span>
                  </li>
                </ul>
                <span id="textoFinalSeccionPotencias" className="size-s clarification"></span>
              </div>                      

            </details>

            <details id="divBloqueOferta" className="accordion">

              <summary className="title">
                <figure className="avatar size-l orange"><span className="material-icon">looks_two</span></figure>
                <div className="content vertical">
                  <span className="size-l">Contrata esta tarifa: <span id="nombreTarifa"></span></span>                
                </div>
              </summary>

              <div className="accordion-content">

                <span id="mensajeComentarioContrataSolarSinPaneles" className="size-m hidden">
                  No nos hemos equivocado, puedes contratar tarifas solares sin tener paneles.
                </span>

                <span>¿No conoces esta compañía? Tranquil@, no te recomendaríamos nada que no hayamos verificado que es de confianza y seguro...</span>

                <a id="aLinkOferta" href="https://www.fevergy.com" target="_blank" rel="noopener noreferrer" className="button primary full-width">Información y contratación</a>
                <div id="bubblePromocionOferta">                  
                  <p id="labelTextoBonificacion" className=" hidden"></p>                  
                </div>

              </div>          
              
                  

            </details>   

            <details id="acordeonAhorroPotencias" className="accordion hidden">

              <summary className="title">
                <div className="vertical">
                  <span className="size-l">Tienes más potencia contratada de la que necesitas.</span>
                  <p id="textoIntroAhorroPotencia"></p>
                </div>
              </summary>

              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong>BALANCE TOTAL</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Balance total</p>
                                <p className="size-s">Ahorro anual por bajada de potencia.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value size-m adhoc-width">Ahora</td>
                      <td className="table-cell value size-m adhoc-width">Tras bajada</td>                      
                    </tr>
                    <tr className="table-row vertical-start">
                      <td className="table-cell horizontal gap-02">                      
                        <span>Total costes potencia anuales</span>
                      </td>
                      <td id="valorBalanceFinalAhorroPotenciaActual" className="table-cell value size-l text"></td>
                      <td id="valorBalanceFinalAhorroPotenciaOferta" className="table-cell value size-l text"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="has-tooltip">
                <table>
                  <tbody>
                    <tr className="table-row table-head has-tooltip">
                      <td className="table-cell">
                        <span className="tooltip-trigger-container size-m">
                          <strong>POTENCIA</strong>
                          <span className="tooltip-trigger">
                            <span className="material-icon tooltip-icon link size-s">info</span>
                            <span className="tooltip bottom">
                              <span className="tooltip-container">
                                <p className="size-m tooltip-title">Gastos de potencia</p>
                                <p className="size-s">Es lo que pagas por la potencia que tienes contratada, es un gasto fijo, te lo cobrarán aunque quites los plomos.</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </td>
                      <td className="table-cell value size-m adhoc-width">Ahora</td>
                      <td className="table-cell value size-m adhoc-width">Tras bajada</td>
                    </tr>
                    
                    <tr className="table-row vertical-start" id="trAhorroPotenciaP1">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>Gastos P1</span>
                          <span className="size-s clarification">Potencia</span>
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP1Actual"></span>
                          <span id="potenciaP1Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP1Oferta"></span>
                          <span id="potenciaP1Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trAhorroPotenciaP2">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>Gastos P2</span>
                          <span className="size-s clarification">Potencia</span>
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP2Actual"></span>
                          <span id="potenciaP2Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP2Oferta"></span>
                          <span id="potenciaP2Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trAhorroPotenciaP3">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>Gastos P3</span>
                          <span className="size-s clarification">Potencia</span>
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP3Actual"></span>
                          <span id="potenciaP3Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP3Oferta"></span>
                          <span id="potenciaP3Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trAhorroPotenciaP4">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>Gastos P4</span>
                          <span className="size-s clarification">Potencia</span>
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP4Actual"></span>
                          <span id="potenciaP4Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP4Oferta"></span>
                          <span id="potenciaP4Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trAhorroPotenciaP5">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>Gastos P5</span>
                          <span className="size-s clarification">Potencia</span>
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP5Actual"></span>
                          <span id="potenciaP5Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP5Oferta"></span>
                          <span id="potenciaP5Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trAhorroPotenciaP6">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>Gastos P6</span>
                          <span className="size-s clarification">Potencia</span>
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP6Actual"></span>
                          <span id="potenciaP6Actual" className="size-s clarification"></span>
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="valorAhorroPotenciaContratadaP6Oferta"></span>
                          <span id="potenciaP6Oferta" className="size-s clarification"></span>
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trCosteBajadaPotencia">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>Coste bajada potencia</span>                        
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="costeBajadaPotenciaActual"></span>                        
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="costeBajadaPotenciaOferta"></span>                        
                        </div>
                      </td>
                    </tr>

                    <tr className="table-row vertical-start" id="trIvaBajadaPotencia">
                      <td className="table-cell horizontal gap-02">                      
                        <div className="vertical gap-01">
                          <span>IVA</span>                        
                        </div>
                      </td>                      
                      <td className="table-cell value text">
                        <div className="vertical gap-01">
                          <span id="ivaBajadaPotenciaActual"></span>                        
                        </div>
                      </td>
                      <td className="table-cell value text green">
                        <div className="vertical gap-01">
                          <span id="ivaBajadaPotenciaOferta"></span>                        
                        </div>
                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>

            </details>

            <details id="acordeonCalculosResultados" className="accordion">

              <summary className="title">
                <figure className="avatar size-l purple"><span className="material-icon">receipt_long</span></figure>
                <div className="vertical">     
                  <span className="size-l">Detalle del análisis</span>
                  <p id="textoIntroCalculos" ></p>
                </div>    
              </summary>

              <div className="accordion-content">

                <div className="has-tooltip">
                  <table>
                    <tbody>
                      <tr className="table-row table-head has-tooltip">
                        <td className="table-cell">
                          <span className="tooltip-trigger-container size-m">
                            <strong>BALANCE TOTAL</strong>
                            <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                              <span className="tooltip bottom">
                                <span className="tooltip-container">
                                  <p className="size-m tooltip-title">Balance total</p>
                                  <p className="size-s">Gastos / ganancias totales de cada tarifa con impuestos incluidos.</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="table-cell value size-m adhoc-width">Ahora</td>
                        <td className="table-cell value size-m adhoc-width">Análisis</td>                      
                      </tr>
                      <tr className="table-row vertical-start">
                        <td className="table-cell horizontal gap-02">                      
                          <span id="literalTotales">Total análisis</span>
                        </td>
                        <td id="valorBalanceFinalActual" className="table-cell value size-l text"></td>
                        <td id="valorBalanceFinalOferta" className="table-cell value size-l text"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="has-tooltip">
                  <table>
                    <tbody>
                      <tr className="table-row table-head has-tooltip">
                        <td className="table-cell">
                          <span className="tooltip-trigger-container size-m">
                            <strong>FEVERGY</strong>
                            <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                              <span className="tooltip bottom">
                                <span className="tooltip-container">
                                  <p className="size-m tooltip-title">Impuestos</p>
                                  <p className="size-s">Estos son nuestros honorarios por haberte hecho el análisis, que se corresponden con el 7,5% del ahorro que te hemos encontrado.</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="table-cell value adhoc-width">Ahora</td>
                        <td className="table-cell value adhoc-width">Análisis</td>
                      </tr>
                      <tr className="table-row vertical-start">
                        <td className="table-cell horizontal gap-02">                      
                          <span id="spanTextoHonorariosFEVERGY"></span>
                        </td>
                        <td id="valorComisionFEVERGYActual" className="table-cell value"></td>
                        <td id="valorComisionFEVERGYOferta" className="table-cell value"></td>
                      </tr>                  
                    </tbody>
                  </table>
                </div>

                <div className="has-tooltip">
                  <table>
                    <tbody>
                      <tr className="table-row table-head has-tooltip">
                        <td className="table-cell">
                          <span className="tooltip-trigger-container size-m">
                            <strong>POTENCIA</strong>
                            <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                              <span className="tooltip bottom">
                                <span className="tooltip-container">
                                  <p className="size-m tooltip-title">Gastos de potencia</p>
                                  <p className="size-s">Es lo que pagas por la potencia que tienes contratada, es un gasto fijo, te lo cobrarán aunque quites los plomos.</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="table-cell value size-m adhoc-width">Ahora</td>
                        <td className="table-cell value size-m adhoc-width">Análisis</td>
                      </tr>
                      
                      <tr className="table-row vertical-start" id="trPotenciaP1">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P1</span>
                            <span className="size-s clarification">Potencia (kW)</span>
                            <span className="size-s clarification">Tarifa (€/kW/Día)</span>
                          </div>
                        </td>                      
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP1Actual"></span>
                            <span id="potenciaContratadaP1Actual" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP1Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP1Oferta"></span>
                            <span id="potenciaContratadaP1Oferta" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP1Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>
                      
                      <tr className="table-row vertical-start" id="trPotenciaP2">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P2</span>
                            <span className="size-s clarification">Potencia (kW)</span>
                            <span className="size-s clarification">Tarifa (€/kW/Día)</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP2Actual"></span>
                            <span id="potenciaContratadaP2Actual" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP2Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP2Oferta"></span>
                            <span id="potenciaContratadaP2Oferta" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP2Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trPotenciaP3">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P3</span>
                            <span className="size-s clarification">Potencia (kW)</span>
                            <span className="size-s clarification">Tarifa (€/kW/Día)</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP3Actual"></span>
                            <span id="potenciaContratadaP3Actual" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP3Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP3Oferta"></span>
                            <span id="potenciaContratadaP3Oferta" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP3Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trPotenciaP4">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P4</span>
                            <span className="size-s clarification">Potencia (kW)</span>
                            <span className="size-s clarification">Tarifa (€/kW/Día)</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP4Actual"></span>
                            <span id="potenciaContratadaP4Actual" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP4Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP4Oferta"></span>
                            <span id="potenciaContratadaP4Oferta" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP4Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trPotenciaP5">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P5</span>
                            <span className="size-s clarification">Potencia (kW)</span>
                            <span className="size-s clarification">Tarifa (€/kW/Día)</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP5Actual"></span>
                            <span id="potenciaContratadaP5Actual" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP5Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP5Oferta"></span>
                            <span id="potenciaContratadaP5Oferta" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP5Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trPotenciaP6">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P6</span>
                            <span className="size-s clarification">Potencia (kW)</span>
                            <span className="size-s clarification">Tarifa (€/kW/Día)</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP6Actual"></span>
                            <span id="potenciaContratadaP6Actual" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP6Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorPotenciaContratadaP6Oferta"></span>
                            <span id="potenciaContratadaP6Oferta" className="size-s clarification"></span>
                            <span id="tarifaPotenciaP6Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>

                <div className="has-tooltip">
                  <table>
                    <tbody>
                      <tr className="table-row table-head has-tooltip">
                        <td className="table-cell">
                          <span className="tooltip-trigger-container size-m">
                            <strong>ENERGÍA</strong>
                            <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                              <span className="tooltip bottom">
                                <span className="tooltip-container">
                                  <p className="size-m tooltip-title">Gastos de energía</p>
                                  <p className="size-s">Estos son los gastos de tu consumo que dependen principalmente de tu instalación y el uso que le das.</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="table-cell value adhoc-width">Ahora</td>
                        <td className="table-cell value adhoc-width">Análisis</td>
                      </tr>

                      <tr className="table-row vertical-start" id="trEnergiaP1">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P1: <span id="consumoEnergiaP1" className="size-s clarification"></span></span>
                            <span className="size-s clarification">Tarifa €/kWh</span>
                          </div>
                        </td>

                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP1Actual"></span>
                            <span id="tarifaEnergiaP1Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP1Oferta"></span>
                            <span id="tarifaEnergiaP1Oferta" className="size-s clarification"></span>
                          </div>
                        </td>

                      </tr>

                      <tr className="table-row vertical-start" id="trEnergiaP2">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P2: <span id="consumoEnergiaP2" className="size-s clarification"></span></span>
                            <span className="size-s clarification">Tarifa €/kWh</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP2Actual"></span>
                            <span id="tarifaEnergiaP2Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP2Oferta"></span>
                            <span id="tarifaEnergiaP2Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trEnergiaP3">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P3: <span id="consumoEnergiaP3" className="size-s clarification"></span></span>
                            <span className="size-s clarification">Tarifa €/kWh</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP3Actual"></span>
                            <span id="tarifaEnergiaP3Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP3Oferta"></span>
                            <span id="tarifaEnergiaP3Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trEnergiaP4">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P4: <span id="consumoEnergiaP4" className="size-s clarification"></span></span>
                            <span className="size-s clarification">Tarifa €/kWh</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP4Actual"></span>
                            <span id="tarifaEnergiaP4Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP4Oferta"></span>
                            <span id="tarifaEnergiaP4Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trEnergiaP5">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P5: <span id="consumoEnergiaP5" className="size-s clarification"></span></span>
                            <span className="size-s clarification">Tarifa €/kWh</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP5Actual"></span>
                            <span id="tarifaEnergiaP5Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP5Oferta"></span>
                            <span id="tarifaEnergiaP5Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row vertical-start" id="trEnergiaP6">
                        <td className="table-cell horizontal gap-02">                      
                          <div className="vertical gap-01">
                            <span>P6: <span id="consumoEnergiaP6" className="size-s clarification"></span></span>
                            <span className="size-s clarification">Tarifa €/kWh</span>
                          </div>
                        </td>
                        <td className="table-cell value text">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP6Actual"></span>
                            <span id="tarifaEnergiaP6Actual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value text green">
                          <div className="vertical gap-01">
                            <span id="valorEnergiaP6Oferta"></span>
                            <span id="tarifaEnergiaP6Oferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                <div id="divBonificaciones" className="has-tooltip">
                  <table>
                    <tbody>
                      <tr className="table-row table-head has-tooltip">
                        <td className="table-cell">
                          <span className="tooltip-trigger-container size-m">
                            <strong>BONIFICACIONES</strong>
                            <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                              <span className="tooltip bottom">
                                <span className="tooltip-container">
                                  <p className="size-m tooltip-title">Bonificaciones</p>
                                  <p className="size-s">Son compensaciones económicas, ya sea por descuentos que te haga tu comercializadora, promociones de referidos o por el excedente solar que vuelvas y vendes a la red.</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="table-cell value adhoc-width">Ahora</td>
                        <td className="table-cell value adhoc-width">Análisis</td>
                      </tr>
                      <tr className="table-row vertical-start" id="trExcedente" >
                        <td className="table-cell horizontal gap-02">      
                          <div className="vertical gap-01">
                            <span>Excedente: <span id="valorExcedente" className="size-s clarification"></span></span>
                            <span className="size-s clarification">Tarifa €/kWh</span>
                          </div>
                        </td>
                        <td className="table-cell value"> 
                          <div className="vertical gap-01">
                            <span id="valorExcedenteActual"></span>
                            <span id="tarifaExcedenteActual" className="size-s clarification"></span>
                          </div>
                        </td>
                        <td className="table-cell value">
                          <div className="vertical gap-01">
                            <span id="valorExcedenteOferta"></span>
                            <span id="tarifaExcedenteOferta" className="size-s clarification"></span>
                          </div>
                        </td>
                      </tr>
                      <tr id="trDescuentos" className="table-row vertical-start">
                        <td className="table-cell horizontal gap-02">                      
                          <span>Descuentos</span>
                        </td>
                        <td id="valorDescuentoActual" className="table-cell value"></td>
                        <td id="valorDescuentoOferta" className="table-cell value"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>                    
                      
                <div className="has-tooltip">
                  <table>
                    <tbody>
                      <tr className="table-row table-head has-tooltip">
                        <td className="table-cell">
                          <span className="tooltip-trigger-container size-m">
                            <strong>OTROS GASTOS</strong>
                            <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                              <span className="tooltip bottom">
                                <span className="tooltip-container">
                                  <p className="size-m tooltip-title">Otros gastos</p>
                                  <p className="size-s">Son cargos adicionales que realiza tu comercializadora en concepto de servicios ofrecidos, como el alquiler de equipos, monedero solar, etc...</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="table-cell value adhoc-width">Ahora</td>
                        <td className="table-cell value adhoc-width">Análisis</td>
                      </tr>
                      <tr className="table-row vertical-start" id="trGastosFijosMonederoSolar">
                        <td className="table-cell horizontal gap-02">                      
                          <span>Monedero solar / Baterías virtuales</span>
                        </td>
                        <td id="valorMonederoSolarActual" className="table-cell value"></td>
                        <td id="valorMonederoSolarOferta" className="table-cell value"></td>
                      </tr>
                      <tr className="table-row vertical-start" id="trGastosFijosAlquilerEquipos">
                        <td className="table-cell horizontal gap-02">                      
                          <span>Servicios y complementos</span>
                        </td>
                        <td id="valorEquiposMedicionActual" className="table-cell value"></td>
                        <td id="valorEquiposMedicionOferta" className="table-cell value"></td>
                      </tr>
                      <tr className="table-row vertical-start" id="trGastosComisionMensualCompañia">
                        <td className="table-cell horizontal gap-02">                      
                          <span>Comisión mensual compañía</span>
                        </td>
                        <td id="valorComisionFijaCompañiaActual" className="table-cell value"></td>
                        <td id="valorComisionFijaCompañiaOferta" className="table-cell value"></td>
                      </tr>
                      <tr className="table-row vertical-start" id="trCosteBajadaPotenciaAnalisisTarifas">
                        <td className="table-cell horizontal gap-02">                      
                          <span>Coste bajada potencia</span>
                        </td>
                        <td id="valorCosteBajadaPotenciaActual" className="table-cell value"></td>
                        <td id="valorCosteBajadaPotenciaOferta" className="table-cell value"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="has-tooltip">
                  <table>
                    <tbody>
                      <tr className="table-row table-head has-tooltip">
                        <td className="table-cell">
                          <span className="tooltip-trigger-container size-m">
                            <strong>IMPUESTOS</strong>
                            <span className="tooltip-trigger">
                              <span className="material-icon tooltip-icon link size-s">info</span>
                              <span className="tooltip bottom">
                                <span className="tooltip-container">
                                  <p className="size-m tooltip-title">Impuestos</p>
                                  <p className="size-s">Estos son los impuestos que te aplicarán y cobrarán.</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </td>
                        <td className="table-cell value adhoc-width">Ahora</td>
                        <td className="table-cell value adhoc-width">Análisis</td>
                      </tr>
                      <tr className="table-row vertical-start">
                        <td className="table-cell horizontal gap-02">                      
                          <span>Bono social</span>
                        </td>
                        <td id="valorBonoSocialActual" className="table-cell value"></td>
                        <td id="valorBonoSocialOferta" className="table-cell value"></td>
                      </tr>
                      <tr className="table-row vertical-start">
                        <td className="table-cell horizontal gap-02">                      
                          <span>Impuesto electricidad</span>
                        </td>
                        <td id="valorImpuestoElectricidadActual" className="table-cell value text"></td>
                        <td id="valorImpuestoElectricidadOferta" className="table-cell value text"></td>
                      </tr>
                      <tr className="table-row vertical-start">
                        <td className="table-cell horizontal gap-02">                      
                          <span id="literalIVAHoy">IVA</span>
                        </td>
                        <td id="importeIVAActual" className="table-cell value text"></td>
                        <td id="importeIVAOferta" className="table-cell value text"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </details>          

          </div>

          <div id="toastInformativo" className="toast" onClick={() => document.getElementById("toastInformativo").className = "toast invisible"}></div>   

        </main>

        <div id="loaderGeneralAplicacion" className="loader hidden" style={{ margin: ""}}>
          <progress aria-label="" style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>          
        </div>
        
      </div>
  )
}

export default Last12BillsAnalysis